const ML_API_URL = process.env.REACT_APP_FACE_DETECTION_URL ?? '';
const TUNNEL_HOST_RE = /\.ngrok\.io|\.loca\.lt|\.tunnelmole\.|cloudflare/i;

/**
 * True when frames should be uploaded in the compact form (fewer, more
 * compressed) — on mobile user agents or when talking through a dev tunnel,
 * where bandwidth is tight.
 */
export const shouldUseCompactCaptureUpload = (): boolean => {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent || "";
  const mobileUa = /iPhone|iPad|iPod|Android/i.test(ua);
  return (
    mobileUa ||
    TUNNEL_HOST_RE.test(window.location.host) ||
    TUNNEL_HOST_RE.test(ML_API_URL)
  );
};
